import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "../../components/hooks/useForm";
import { PayfacContext } from "../../context/payfac/PayfacContext";
import Message from "../../components/ui/Message";

export const PayfacPage = () => {

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const navigate = useNavigate();
    const location = useLocation();

    const { state } = location;

    const { addPayfac, updatePayfac } = useContext(PayfacContext);

    const [isFormValid, setIsFormValid] = useState(false);

    const payfac = state?.payfac || {

        id: -1,
        name: "",
        regnumber: "",
        prefix: "",
        mc_payfac_id: "",
        vi_payfac_id: ""

    };

    const { formState, onInputChange } = useForm(payfac);

    const { id, name, regnumber, prefix, mc_payfac_id, vi_payfac_id } = formState;

    useEffect(() => {

        const valid =
            name.length > 0 &&
            regnumber.length > 0 &&
            prefix.length > 0;

        setIsFormValid(valid);

    }, [name, regnumber, prefix]);

    const handleSave = async () => {

        let resp = "";

        if (id > 0) {

            resp = await updatePayfac(formState);

        } else {

            formState.id = undefined;
            resp = await addPayfac(formState);

        }

        if (resp == "success") {

            setSuccessMessage(
                id > 0
                    ? "Payfac actualizado correctamente"
                    : "Payfac creado correctamente."
            );

        } else {

            setErrorMessage(resp);

        }

    };

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSuccess = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className="container mt-5">

            <div className="row justify-content-center">

                <div className="col-md-6">

                    <h3>
                        {id > 0 ? "Actualizar Payfac" : "Crear Payfac"}
                    </h3>

                    <hr />

                    <form className="row g-3">

                        <div className="mb-3">

                            <label className="form-label">
                                Nombre
                            </label>

                            <input
                                className="form-control"
                                name="name"
                                value={name}
                                onChange={onInputChange}
                            />

                        </div>

                        <div className="mb-3">

                            <label className="form-label">
                                Número de registro (Registration number)
                            </label>

                            <input
                                className="form-control"
                                name="regnumber"
                                value={regnumber}
                                onChange={onInputChange}
                            />

                        </div>

                        <div className="mb-3">

                            <label className="form-label">
                                Prefix
                            </label>

                            <input
                                className="form-control"
                                name="prefix"
                                value={prefix}
                                onChange={onInputChange}
                            />

                        </div>

                        <div className="mb-3">

                            <label className="form-label">
                                MC Payfac ID
                            </label>

                            <input
                                className="form-control"
                                name="mc_payfac_id"
                                value={mc_payfac_id}
                                onChange={onInputChange}
                            />

                        </div>

                        <div className="mb-3">

                            <label className="form-label">
                                VI Payfac ID
                            </label>

                            <input
                                className="form-control"
                                name="vi_payfac_id"
                                value={vi_payfac_id}
                                onChange={onInputChange}
                            />

                        </div>

                        <div className="container d-flex align-items-center justify-content-center mt-4">

                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                className="btn btn-outline-secondary"
                            >
                                Atrás
                            </button>

                            <button
                                type="button"
                                onClick={handleSave}
                                className="btn btn-primary ms-4"
                                disabled={!isFormValid}
                            >
                                Guardar
                            </button>

                        </div>

                    </form>

                </div>

                {
                    errorMessage.length > 0
                        ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} />
                        : ''
                }

                {
                    successMessage.length > 0
                        ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSuccess} handleOk={removeSuccess} />
                        : ''
                }

            </div>

        </div>

    );
};